module.exports = __webpack_public_path__ + "img/Vip_Card_2.8bc0df3e.png";